<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row m-0 g-0">
    <div class="col-md-3 p-0">
      <app-folders></app-folders>
    </div>

    <div
      class="col-md-9 container"
      style="
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        overflow: hidden;
        margin-top: 0 !important;
        margin-left: -7px;
      "
    >
      <div class="card" style="height: 1000px">
        <div class="card-body">
          <div
            class="d-flex justify-content-start"
            style="margin-top: 0 !important"
          >
            <button
              type="button"
              class="btn custom-button"
              style="margin-bottom: 10px"
              (click)="goBack()"
            >
              Back
            </button>
            <!--changed class and margin-->
          </div>

          <!-- new -->
          <div
            class="new-card"
            style="
              border: 2px solid #4a148c;
              border-radius: 12px;
              padding: 10px 20px;
              background-color: #ffffff;
              box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);
              margin-bottom: -15px;
              font-family: 'Segoe UI', sans-serif;
            "
          >
            <div class="card-content">
              <div
                class="row d-flex align-items-center justify-content-between flex-wrap"
                style="gap: 12px; font-size: 15px; color: #333"
              >
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Study Code:</strong>
                  {{ studyCode }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Study Name:</strong>
                  {{ studyName }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Subject Name:</strong>
                  {{ subjectName }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Site Location:</strong>
                  {{ siteLocation }}
                </div>
              </div>
            </div>
          </div>

          <!-- Informed Consent Form -->
          <div *ngIf="formName === 'informed-consent'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Informed Consent Form</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div class="form-container">
                  <div
                    class="form-group"
                    data-label="Did the Subject read, understand, and sign the Informed Consent form"
                  >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <label class="m-0"
                        >Did the Subject read, understand, and sign the Informed
                        Consent form</label
                      >
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Did the Subject read, understand, and sign the Informed Consent form'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -20px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !isConsentData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !isConsentData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                               [disabled]="
                              !isConsentData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="consentYes"
                          name="consentSigned"
                          value="yes"
                          [(ngModel)]="formData.consentSigned"
                          [disabled]="isConsentDisabled"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="consentNo"
                          name="consentSigned"
                          value="no"
                          [(ngModel)]="formData.consentSigned"
                          [disabled]="isConsent2Disabled"
                        />
                        <input type="radio" id="consentNo" name="consentSigned" value="no" [(ngModel)]="formData.consentSigned" [disabled]="isConsentDisabled">
                        <span>No</span>
                      </label>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    data-label="Language of Informed Consent Form given to the patient:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label
                        >Language of Informed Consent Form given to the
                        patient:</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 7px"
                      >
                        ⋮
                      </div>
                    </div>

                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <select
                        class="form-control"
                        [(ngModel)]="formData.language"
                        name="language"
                        [disabled]="isLanguageDisabled"
                      >
                        <option value="">-- Select an option --</option>
                        <option value="Malayalam">Malayalam</option>
                        <option value="English">English</option>
                        <option value="Hindi">Hindi</option>
                      </select>
                      <!-- <input type="date" class="form-control" [(ngModel)]="formData.studyCompletionDate" name="studyCompletionDate" [min]="screeningMinDate" [max]="todayDate" required> -->
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          'Language of Informed Consent Form given to the patient:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 52px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasLanguageData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasLanguageData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasLanguageData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--<div class="form-group">
                    <label>Date Subject signed the informed consent form:</label>
                    <input type="date" class="form-control" [(ngModel)]="formData.consentDate" name="consentDate">
                  </div>-->
                  <!-- Informed Consent Date Field -->
                  <div class="form-group" data-label="Date of Signing">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label>Date of Signing</label>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        class="form-control"
                        name="consentDate"
                        [(ngModel)]="formData.consentDate"
                        [max]="todayDate"
                        [disabled]="isDatePickerDisabled"
                      />

                      <!-- <input type="date" class="form-control" [(ngModel)]="formData.studyCompletionDate" name="studyCompletionDate" [min]="screeningMinDate" [max]="todayDate" required> -->
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen && fieldLabel === 'Date of Signing'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 150px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                               [disabled]="
                                !hasDateOfSignData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                               [disabled]="
                                !hasDateOfSignData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                               [disabled]="
                                !hasDateOfSignData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--<div class="form-group">
                    <label>Time Subject signed the informed consent form:</label>
                    <input type="time" class="form-control" [(ngModel)]="formData.consentTime" name="consentTime" step="60">

                  </div>-->
                  <!-- Informed Consent Time Field -->
                  <div class="form-group" data-label="Time of Signing">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label>Time of Signing</label>
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="time"
                        class="form-control"
                        name="consentTime"
                        [(ngModel)]="formData.consentTime"
                        min="09:00"
                        max="18:00"
                        required
                        [disabled]="isTimePickerDisabled"
                      />

                      <!-- <input type="date" class="form-control" [(ngModel)]="formData.studyCompletionDate" name="studyCompletionDate" [min]="screeningMinDate" [max]="todayDate" required> -->
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen && fieldLabel === 'Time of Signing'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 252px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button  type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                               [disabled]="
                                !hasTimeOfSignData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                               [disabled]="
                                !hasTimeOfSignData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTimeOfSignData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- Screening Visit Date Form -->
          <div *ngIf="formName === 'Screening Visit Date'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Screening Visit Date</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div class="form-container">
                  <div
                    class="form-group"
                    data-label="1. Date of Screening Visit:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label for="screeningDate"
                        >1. Date of Screening Visit:</label
                      >
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="date"
                        [(ngModel)]="formData.screeningDate1"
                        class="form-control"
                        [min]="screeningMinDate"
                        [max]="todayDate"
                        [disabled]="isScreeningDisabled"
                      />
                      <!-- <input type="date" class="form-control" [(ngModel)]="formData.studyCompletionDate" name="studyCompletionDate" [min]="screeningMinDate" [max]="todayDate" required> -->
                    </div>

                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '1. Date of Screening Visit:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -20px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                               [disabled]="
                                !hasDateOfScreeningData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                               [disabled]="
                                !hasDateOfScreeningData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                               [disabled]="
                                !hasDateOfScreeningData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!--DEMOGRAPHY FORM -->
          <div *ngIf="formName === 'demography'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Demography Information</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <!-- Gender Field (Dropdown) -->
                <div class="form-group" data-label="1. Gender:">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <label for="gender">1. Gender:</label>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <select
                      id="gender"
                      [(ngModel)]="formData.gender"
                      name="gender"
                      class="form-control"
                      required
                      [disabled]="isGenderDisabled"
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    <!-- <input type="date" class="form-control" [(ngModel)]="formData.studyCompletionDate" name="studyCompletionDate" [min]="screeningMinDate" [max]="todayDate" required> -->
                  </div>

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="isOptionsModalOpen && fieldLabel === '1. Gender:'"
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button  type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                                !hasGenderData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                                !hasGenderData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                                !hasGenderData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Date of Birth Field -->
                <div
                  class="form-group mt-2"
                  data-label="2. Date of Birth (DD/MMM/YYYY):"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <label for="dob">2. Date of Birth (DD/MMM/YYYY):</label>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="date"
                      id="dob"
                      [(ngModel)]="formData.dateOfBirth"
                      name="dateOfBirth"
                      class="form-control"
                      (change)="updateAge()"
                      [max]="todayDate"
                      required
                      [disabled]="isDatePickerDisabled3"
                    />
                    <!-- <input type="date" class="form-control" [(ngModel)]="formData.studyCompletionDate" name="studyCompletionDate" [min]="screeningMinDate" [max]="todayDate" required> -->
                  </div>

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '2. Date of Birth (DD/MMM/YYYY):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 140px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                                !hasDOBData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                                !hasDOBData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                                !hasDOBData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Auto-Calculated Age Field -->
                <div
                  class="form-group mt-2"
                  data-label="3. Age (Years & Months):"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <label for="age">3. Age (Years & Months):</label>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="text"
                      id="age"
                      [(ngModel)]="formData.age"
                      name="age"
                      class="form-control"
                      readonly
                      [disabled]="isAgeDisabled"
                    />
                    <!-- <input type="date" class="form-control" [(ngModel)]="formData.studyCompletionDate" name="studyCompletionDate" [min]="screeningMinDate" [max]="todayDate" required> -->
                  </div>

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '3. Age (Years & Months):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 240px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                                !hasAgeData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                                !hasAgeData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                                !hasAgeData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Buttons: Back & Submit -->
                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- ANTHROPOMETRIC DATA FORM -->
          <div *ngIf="formName === 'anthropometric-data'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Anthropometric Data</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="validateForm()" #form="ngForm">
                <div class="form-container">
                  <!-- Weight Field -->
                  <div class="form-group" data-label="1. Weight (kg):">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label for="weight"
                        ><strong>1. Weight (kg):</strong></label
                      >

                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <input
                      type="text"
                      id="weight"
                      [(ngModel)]="formData.weight"
                      name="weight"
                      class="form-control"
                      placeholder="000.00 kg"
                      pattern="^\d{3}\.\d{2}$"
                      (input)="calculateBMI()"
                      #weight="ngModel"
                      [disabled]="isWeightDisabled"
                    />
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen && fieldLabel === '1. Weight (kg):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: -20px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>

                 <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasWeightData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasWeightData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasWeightData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->
                  <!-- Height Field -->
                  <div class="form-group mt-2" data-label="2. Height (m):">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label for="height"
                        ><strong>2. Height (m):</strong></label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <input
                      type="text"
                      id="height"
                      [(ngModel)]="formData.height"
                      name="height"
                      class="form-control"
                      placeholder="00.00 m"
                      pattern="^\d{2}\.\d{2}$"
                      (input)="calculateBMI()"
                      #height="ngModel"
                      [disabled]="isHeightDisabled"
                    />
                  </div>

                  <!-- start of : -->

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen && fieldLabel === '2. Height (m):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 79px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>

                <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasHeightData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasHeightData || !reviewOptions.dataMonitor || userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasHeightData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <!-- Waist Circumference Field -->
                  <!-- Waist Circumference Field -->
                  <div
                    class="form-group mt-2"
                    data-label="3. Waist Circumference (cm) (Part of IDRS Assessment):"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label for="waist"
                        ><strong
                          >3. Waist Circumference (cm) (Part of IDRS
                          Assessment):</strong
                        ></label
                      >
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <input
                      type="text"
                      id="waist"
                      [(ngModel)]="formData.waistCircumference"
                      name="waistCircumference"
                      class="form-control"
                      placeholder="000.00 cm"
                      pattern="^\d{3}\.\d{2}$"
                      #waist="ngModel"
                      [disabled]="isCircumferenceDisabled"
                    />
                  </div>
                  <!-- start of : -->
                  <!-- Menu Icon -->

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '3. Waist Circumference (cm) (Part of IDRS Assessment):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 175px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>

                  <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasWaistData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasWaistData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasWaistData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <!-- BMI (Auto-Calculated) -->
                  <!-- BMI (Auto-Calculated) -->
                  <div
                    class="form-group mt-2"
                    data-label="Body Mass Index (BMI):"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label for="bmi"
                        ><strong>4. Body Mass Index (BMI):</strong></label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <input
                      type="text"
                      id="bmi"
                      [(ngModel)]="formData.bmi"
                      name="bmi"
                      class="form-control"
                      placeholder="00.0 BMI"
                      readonly
                      [disabled]="isBmiDisabled"
                    />
                  </div>

                  <!-- start of : -->

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Body Mass Index (BMI):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 275px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                 <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="!hasBMIData || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="!hasBMIData || !reviewOptions.dataMonitor || userDesignation !== 'monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="!hasBMIData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <!-- Buttons: Back & Submit -->
                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- MEDICAL HISTORY FORM -->
          <div *ngIf="formName === 'medical-history'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Medical History</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="Does the subject have any relevant medical history"
                >
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                    style="margin-top: 3px"
                  >
                    <label
                      >Does the subject have any relevant medical
                      history?</label
                    >

                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>

                  <div class="radio-group">
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="medicalHistoryYes"
                        name="medicalHistory"
                        value="yes"
                        [(ngModel)]="formData.medicalHistory"
                        (change)="checkMedicalHistory()"
                        required
                        [disabled]="isR1Disabled"
                      />
                      <span>Yes</span>
                    </label>
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="medicalHistoryNo"
                        name="medicalHistory"
                        value="no"
                        [(ngModel)]="formData.medicalHistory"
                        (change)="checkMedicalHistory()"
                        required
                        [disabled]="isR2Disabled"
                      />
                      <span>No</span>
                    </label>
                  </div>

                  <!-- Medical Conditions Table (Only visible if 'Yes' is selected) -->
                  <div *ngIf="formData.medicalHistory === 'yes'" class="mt-4">
                    <h6>Medical Conditions</h6>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Condition</th>
                          <th>Duration</th>
                          <th>Treatment</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let condition of formData.medicalConditions;
                            let i = index
                          "
                        >
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="condition.condition"
                              name="condition{{ i }}"
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="condition.duration"
                              name="duration{{ i }}"
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="condition.treatment"
                              name="treatment{{ i }}"
                              required
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-danger btn-sm"
                              (click)="removeMedicalCondition(i)"
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <button
                      type="button"
                      class="btn custom-button btn-sm mt-2"
                      (click)="addMedicalCondition()"
                    >
                      Add Condition
                    </button>
                  </div>
                </div>

                <!-- start of : -->
                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="
                    isOptionsModalOpen &&
                    fieldLabel ===
                      'Does the subject have any relevant medical history'
                  "
                  (click)="$event.stopPropagation()"
                  style="margin-right: 55px; margin-top: 45px"
                >
                  <div class="modal-buttons">
                    <button (click)="openModal()">Query</button>
                    <button (click)="editStudy()">Edit</button>
                    <button type="button" (click)="openReviewModal()">Review</button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn btn-primary"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn btn-secondary"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="!hasMedicalHistoryData || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="!hasMedicalHistoryData || !reviewOptions.dataMonitor || userDesignation !== 'monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="!hasMedicalHistoryData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                <!-- Query Modal -->
                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong> -
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}
                                <p>{{ entry.message }}</p>
                              </div>
                            </div>

                            <!-- Footer Buttons -->
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- end of :-->
                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- PRIOR MEDICATION FORM -->
          <div *ngIf="formName === 'prior-medication'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Prior Medication</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="Any relevant medications taken by subject within the last 1 month up to screening visit"
                >
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                    style="margin-top: 3px"
                  >
                    <label
                      >Any relevant medications taken by subject within the last
                      1 month up to screening visit</label
                    >
                    <!-- <input type="date" class="form-control" [(ngModel)]="formData.studyCompletionDate" name="studyCompletionDate" [min]="screeningMinDate" [max]="todayDate" required> -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        'Any relevant medications taken by subject within the last 1 month up to screening visit'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 45px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button  type="button"(click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                              !hasPriorMedicationData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasPriorMedicationData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                              !hasPriorMedicationData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div class="radio-group">
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="priorMedYes"
                        name="priorMedication"
                        value="yes"
                        [(ngModel)]="formData.priorMedication"
                        (change)="checkPriorMedication()"
                        required
                        [disabled]="isR3Disabled"
                      />
                      <span>Yes</span>
                    </label>
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="priorMedNo"
                        name="priorMedication"
                        value="no"
                        [(ngModel)]="formData.priorMedication"
                        (change)="checkPriorMedication()"
                        required
                        [disabled]="isR4Disabled"
                      />
                      <span>No</span>
                    </label>
                  </div>
                  <!-- Prior Medication Table (Only visible if 'Yes' is selected) -->
                  <!-- Show button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.priorMedication === 'yes'">
                    <button
                      type="button"
                      class="btn custom-button"
                      (click)="navigateToPriorMedication()"
                    >
                      Add Prior Medication Data
                    </button>
                  </div>
                </div>

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- VITAL SIGNS FORM -->
          <div *ngIf="formName === 'vital-signs'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Vital Signs Evaluation</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()" #vitalForm="ngForm">
                <div
                  class="form-group"
                  data-label="Was vital signs evaluation performed"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                    style="margin-top: 3px"
                  >
                    <label>Was vital signs evaluation performed?</label>
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div class="radio-group">
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="vitalYes"
                        name="vitalSigns"
                        value="yes"
                        [(ngModel)]="formData.vitalSigns"
                        (change)="checkVitalSigns()"
                        required
                      />
                      <span>Yes</span>
                    </label>
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="vitalNo"
                        name="vitalSigns"
                        value="no"
                        [(ngModel)]="formData.vitalSigns"
                        (change)="checkVitalSigns()"
                        required
                      />
                      <span>No</span>
                    </label>
                  </div>
                  <!-- Show the button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.vitalSigns === 'yes'">
                    <button
                      type="button"
                      class="btn custom-button"
                      (click)="navigateToVitalSigns()"
                    >
                      Add Vital Signs Data
                    </button>
                  </div>
                  <!-- Show  only when "No" is selected -->
                  <div class="mt-3" *ngIf="formData.vitalSigns === 'no'">
                    <label>Please provide comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.vitalSignsComments"
                      name="vitalSignsComments"
                      #vitalCommentsRef="ngModel"
                      required
                    ></textarea>
                    <div
                      *ngIf="vitalComments.invalid && vitalComments.touched"
                      class="text-danger"
                    >
                      Comments are required when 'No' is selected.
                    </div>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Was vital signs evaluation performed'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 45px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                              !hasVitalSignData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasVitalSignData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                              !hasVitalSignData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- PHYSICAL AND SYSTEMIC EXAMINATION FORM -->
          <div *ngIf="formName === 'physical-exam'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Physical and Systemic Examination</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="Was physical and systemic examination performed"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                    style="margin-top: 3px"
                  >
                    <label
                      >Was physical and systemic examination performed?</label
                    >
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div class="radio-group">
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="physYes"
                        name="physicalExam"
                        value="yes"
                        [(ngModel)]="formData.physicalExam"
                        (change)="checkPhysicalExam()"
                        required
                        [disabled]="isR7Disabled"
                      />
                      <span>Yes</span>
                    </label>
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="physNo"
                        name="physicalExam"
                        value="no"
                        [(ngModel)]="formData.physicalExam"
                        (change)="checkPhysicalExam()"
                        required
                        [disabled]="isR8Disabled"
                      />
                      <span>No</span>
                    </label>
                  </div>
                  <div class="mt-3" *ngIf="formData.physicalExam === 'no'">
                    <label>Please provide comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.physicalExamComments"
                      name="physicalExamComments"
                      required
                    ></textarea>
                  </div>
                  <!-- Show the button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.physicalExam === 'yes'">
                    <button
                      type="button"
                      class="btn custom-button"
                      (click)="navigateToPhysicalSystemic()"
                    >
                      Add Physical and Systemic Examination Data
                    </button>
                  </div>
                </div>

                <!-- start of : -->
                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="
                    isOptionsModalOpen &&
                    fieldLabel ===
                      'Was physical and systemic examination performed'
                  "
                  (click)="$event.stopPropagation()"
                  style="margin-right: 55px; margin-top: 45px"
                >
                  <div class="modal-buttons">
                    <button (click)="openModal()">Query</button>
                    <button (click)="editStudy()">Edit</button>
                    <button type="button" (click)="openReviewModal()">Review</button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn btn-primary"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn btn-secondary"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasPhysicalExamData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasPhysicalExamData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasPhysicalExamData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                <!-- Query Modal -->
                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong> -
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}
                                <p>{{ entry.message }}</p>
                              </div>
                            </div>

                            <!-- Footer Buttons -->
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- Pregnancy Declaration -->
          <!-- <div *ngIf="formName === 'pregnancy-declaration'" class="card mt-4" style="border: 2px solid #673AB7; border-radius: 8px; padding: 0px; background-color: #fff;">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="m-0">Pregnancy Declaration (by the subject)</h5>
              <button type="button" class="btn custom-button">Create Field</button>
            </div>

            <div *ngIf = "gender !== 'Male'"  class="card-body">
              <form (ngSubmit)="submitForm()">
                <div class="form-group">
                  <label>1. Ask the subject “Are you currently pregnant?”</label>
            <select class="form-control" [(ngModel)]="formData.pregnancyStatus" name="pregnancyStatus"  
                    >
              <option value="">-- Select an option --</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
              <option value="NA">N/A</option>
            </select>
                </div>

                <div *ngIf="dataEntryDisabled" class="alert alert-danger mt-3">
                  <strong>Data entry is stopped due to pregnancy declaration.</strong>
                </div>

                <div class="d-flex justify-content-between mt-3">
                  <button type="button" class="btn custom-button" (click)="goBack()">Back</button>
                  <button type="submit" class="btn custom-button" [disabled]="dataEntryDisabled">Submit</button>
                </div>
              </form>
            </div>
          </div> -->

          <div *ngIf="formName === 'pregnancy-declaration'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Urine Pregnancy Test</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div *ngIf="gender !== 'Male'" class="card-body">
              <form (ngSubmit)="submitForm()">
                <!-- Date of Last Menstrual Period (LMP) -->
                <div
                  class="form-group"
                  data-label="Date of Last Menstrual Period (LMP)"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <label>Date of Last Menstrual Period (LMP)</label>
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <input
                    type="date"
                    class="form-control"
                    [(ngModel)]="formData.lmpDate"
                    name="lmpDate"
                    [max]="todayDate"
                    required
                    [disabled]="isDateUtpDisabled"
                  />
                </div>
                <!-- start of : -->
                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="
                    isOptionsModalOpen &&
                    fieldLabel === 'Date of Last Menstrual Period (LMP)'
                  "
                  (click)="$event.stopPropagation()"
                  style="margin-right: 55px; margin-top: 43px"
                >
                  <div class="modal-buttons">
                    <button (click)="openModal()">Query</button>
                    <button (click)="editStudy()">Edit</button>
                    <button type="button" (click)="openReviewModal()">Review</button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn btn-primary"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn btn-secondary"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>

               <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasLMPData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label for="reviewedByDataMonitor" style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;">
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasLMPData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label for="reviewedByMonitor" style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;">
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasLMPData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label for="reviewedByPI" style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;">
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                <!-- Query Modal -->
                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong> -
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}
                                <p>{{ entry.message }}</p>
                              </div>
                            </div>

                            <!-- Footer Buttons -->
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- end of :-->

                <!-- Was Urine Pregnancy Test (UPT) done? -->
                <div
                  class="form-group mt-2"
                  data-label="Was Urine Pregnancy Test (UPT) done"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <label>Was Urine Pregnancy Test (UPT) done?</label>
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <select
                    class="form-control"
                    [(ngModel)]="formData.uptDone"
                    name="uptDone"
                    (change)="handleUptDoneChange()"
                    required
                    [disabled]="isSelectUtpDisabled"
                  >
                    <option value="">Select</option>
                    <option value="YES">Yes</option>
                    <option value="NO">No</option>
                    <option value="NA">Not Applicable</option>
                  </select>
                </div>
                <!-- start of : -->
                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="
                    isOptionsModalOpen &&
                    fieldLabel === 'Was Urine Pregnancy Test (UPT) done'
                  "
                  (click)="$event.stopPropagation()"
                  style="margin-right: 55px; margin-top: 142px"
                >
                  <div class="modal-buttons">
                    <button (click)="openModal()">Query</button>
                    <button (click)="editStudy()">Edit</button>
                    <button type="button" (click)="openReviewModal()">Review</button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn btn-primary"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn btn-secondary"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>

               <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="!hasUPTDoneData || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="!hasUPTDoneData || !reviewOptions.dataMonitor || userDesignation !== 'monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="!hasUPTDoneData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                <!-- Query Modal -->
                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong> -
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}
                                <p>{{ entry.message }}</p>
                              </div>
                            </div>

                            <!-- Footer Buttons -->
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- end of :-->

                <!-- UPT Result - Shown only if UPT Done is YES -->
                <div
                  class="form-group mt-2"
                  *ngIf="formData.uptDone === 'YES'"
                  data-label="UPT Result"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <label>UPT Result</label>
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <select
                    class="form-control"
                    [(ngModel)]="formData.uptResult"
                    name="uptResult"
                    (change)="handleUptResultChange()"
                    required
                    [disabled]="isSelect2UtpDisabled"
                  >
                    <option value="">Select</option>
                    <option value="Positive">Positive</option>
                    <option value="Negative">Negative</option>
                    <option value="Referred for confirmation">
                      Referred for confirmation
                    </option>
                  </select>
                </div>
                <!-- start of : -->
                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="isOptionsModalOpen && fieldLabel === 'UPT Result'"
                  (click)="$event.stopPropagation()"
                  style="margin-right: 55px; margin-top: 240px"
                >
                  <div class="modal-buttons">
                    <button (click)="openModal()">Query</button>
                    <button (click)="editStudy()">Edit</button>
                    <button type="button"  (click)="openReviewModal()">Review</button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn btn-primary"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn btn-secondary"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>

               <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasUPTResultData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasUPTResultData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasUPTResultData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                <!-- Query Modal -->
                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong> -
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}
                                <p>{{ entry.message }}</p>
                              </div>
                            </div>

                            <!-- Footer Buttons -->
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- end of :-->

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- IDRS Assessment Section -->
          <div *ngIf="formName === 'idrs'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">IDRS - Indian Diabetes Risk Score Assessment</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="Was IDRS Assessment performed"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                    style="margin-top: 3px"
                  >
                    <label>Was IDRS Assessment performed?</label>
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div class="radio-group">
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="idrsYes"
                        name="idrsAssessment"
                        value="yes"
                        [(ngModel)]="formData.idrsAssessment"
                        (change)="checkIDRSAssessment()"
                        required
                        [disabled]="isR9Disabled"
                      />
                      <span>Yes</span>
                    </label>
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="idrsNo"
                        name="idrsAssessment"
                        value="no"
                        [(ngModel)]="formData.idrsAssessment"
                        (change)="checkIDRSAssessment()"
                        required
                        [disabled]="isR10Disabled"
                      />
                      <span>No</span>
                    </label>
                  </div>

                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Was IDRS Assessment performed'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 45px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                                !hasIDRSData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                                !hasIDRSData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasIDRSData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- Show comments field only if No is selected -->
                  <div class="mt-3" *ngIf="formData.idrsAssessment === 'no'">
                    <label for="idrsComments">Comments:</label>
                    <textarea
                      id="idrsComments"
                      [(ngModel)]="formData.idrsAssessmentComments"
                      class="form-control"
                      name="idrsAssessmentComments"
                      required
                    ></textarea>
                  </div>

                  <!-- Show the button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.idrsAssessment === 'yes'">
                    <button
                      type="button"
                      class="btn custom-button"
                      (click)="navigateToIDRS('idrs-examination')"
                    >
                      Add IDRS Data
                    </button>
                  </div>
                </div>

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- LABORATORY INVESTIGATION FORM -->
          <div
            *ngIf="formName === 'laboratory-investigation'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Laboratory Investigation</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="Was Laboratory Investigation performed"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                    style="margin-top: 3px"
                  >
                    <label>Was Laboratory Investigation performed?</label>
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div class="radio-group">
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="labYes"
                        name="labInvestigation"
                        value="yes"
                        [(ngModel)]="formData.labInvestigation"
                        (change)="checkLabInvestigation()"
                        required
                        [disabled]="isR11Disabled"
                      />
                      <span>Yes</span>
                    </label>
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="labNo"
                        name="labInvestigation"
                        value="no"
                        [(ngModel)]="formData.labInvestigation"
                        (change)="checkLabInvestigation()"
                        required
                        [disabled]="isR12Disabled"
                      />
                      <span>No</span>
                    </label>
                  </div>

                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Was Laboratory Investigation performed'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 45px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="!hasLabData || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="!hasLabData || !reviewOptions.dataMonitor || userDesignation !== 'monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="!hasLabData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <!-- Comments field when No is selected -->
                  <div class="mt-3" *ngIf="formData.labInvestigation === 'no'">
                    <label>Please provide comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.labInvestigationComments"
                      name="labInvestigationComments"
                      required
                    ></textarea>
                  </div>
                  <!-- Show the button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.labInvestigation === 'yes'">
                    <button
                      type="button"
                      class="btn custom-button"
                      (click)="navigateToLaboratory()"
                    >
                      Add Laboratory Investigation Data
                    </button>
                  </div>
                </div>

                <!-- Date of Sample Collection -->
                <div
                  class="form-group mt-2"
                  data-label="Date of Sample Collection"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <label for="sampleDate"
                      ><strong>Date of Sample Collection</strong></label
                    >
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <input
                    type="date"
                    id="sampleDate"
                    class="form-control"
                    [(ngModel)]="formData.sampleCollectionDate"
                    name="sampleCollectionDate"
                    [min]="screeningMinDate"
                    [max]="todayDate"
                    required
                    [disabled]="isLabDDisabled"
                  />
                </div>
                <!-- start of : -->
                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="
                    isOptionsModalOpen &&
                    fieldLabel === 'Date of Sample Collection'
                  "
                  (click)="$event.stopPropagation()"
                  [ngStyle]="
                  {
    'margin-top': formData.labInvestigation === 'yes' ? '180px' :
              formData.labInvestigation === 'no' ? '215px' :
              '120px' ,
             'margin-right': '55px'
  }"
                >
                  <div class="modal-buttons">
                    <button (click)="openModal()">Query</button>
                    <button (click)="editStudy()">Edit</button>
                    <button  type="button" (click)="openReviewModal()">Review</button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn btn-primary"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn btn-secondary"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasDateOfSampleData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasDateOfSampleData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasDateOfSampleData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                <!-- Query Modal -->
                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong> -
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}
                                <p>{{ entry.message }}</p>
                              </div>
                            </div>

                            <!-- Footer Buttons -->
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- end of :-->

                <!-- Time of Sample Collection -->
                <div
                  class="form-group mt-2"
                  data-label="Time of Sample Collection"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <label for="sampleTime"
                      ><strong>Time of Sample Collection</strong></label
                    >
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <input
                    type="time"
                    id="sampleTime"
                    class="form-control"
                    [(ngModel)]="formData.sampleCollectionTime"
                    name="sampleCollectionTime"
                    required
                    [disabled]="isLabTDisabled"
                  />
                </div>

                <!-- start of : -->
                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="
                    isOptionsModalOpen &&
                    fieldLabel === 'Time of Sample Collection'
                  "
                  (click)="$event.stopPropagation()"
                  [ngStyle]="
                                     {
    'margin-top': formData.labInvestigation === 'yes' ? '280px' :
              formData.labInvestigation === 'no' ? '315px' :
              '220px' ,
             'margin-right': '55px'
  }"
                >
                  <div class="modal-buttons">
                    <button (click)="openModal()">Query</button>
                    <button (click)="editStudy()">Edit</button>
                    <button type="button" (click)="openReviewModal()">Review</button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn btn-primary"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn btn-secondary"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="!hasTimeOfSampleData || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="!hasTimeOfSampleData || !reviewOptions.dataMonitor || userDesignation !== 'monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="!hasTimeOfSampleData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                <!-- Query Modal -->
                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong> -
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}
                                <p>{{ entry.message }}</p>
                              </div>
                            </div>

                            <!-- Footer Buttons -->
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- end of :-->

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Inclusion and Exclusion Criteria Form -->
          <div *ngIf="formName === 'inclusion-exclusion'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">
                Assessment of Inclusion and Exclusion Criteria
              </h5>
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <!-- Add 'overflow-y: auto;' to enable scrolling if content overflows -->
               <div class="form-container">
                  <!-- Inclusion Criteria -->
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">Inclusion Criteria</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="1. Age is between 35 years and 60 years (both ages included):"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label
                        >1. Age is between 35 years and 60 years (both ages
                        included):</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <select
                      class="form-control"
                      [(ngModel)]="criteria.age"
                      name="age"
                      required
                      [disabled]="isInc1Disabled"
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">NA</option>
                    </select>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Age is between 35 years and 60 years (both ages included):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 50px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button  type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                 <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasInc1Data || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasInc1Data ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasInc1Data ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div
                    class="form-group"
                    data-label="2. Moderate or High-Risk category according to Indian Diabetes Risk Score:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                      style="margin-top: 3px"
                    >
                      <label
                        >2. Moderate or High-Risk category according to
                        assessment using the Indian Diabetes Risk Score.
                        (Moderate-Risk - Score 30-60. High-Risk – Score more
                        than equals to 60):</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <select
                      class="form-control"
                      [(ngModel)]="criteria.riskCategory"
                      name="riskCategory"
                      required
                      [disabled]="isInc2Disabled"
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">NA</option>
                    </select>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '2. Moderate or High-Risk category according to Indian Diabetes Risk Score:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 156px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
               <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="!hasInc2Data || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasInc2Data ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasInc2Data ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div
                    class="form-group"
                    data-label="3. HbA1c value in the range 5.7% - 6.4%:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label
                        >3. HbA1c value in the range 5.7% - 6.4% (both values
                        included):</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <select
                      class="form-control"
                      [(ngModel)]="criteria.hba1c"
                      name="hba1c"
                      required
                      [disabled]="isInc3Disabled"
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">NA</option>
                    </select>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '3. HbA1c value in the range 5.7% - 6.4%:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 255px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button  type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                 <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasInc3Data || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasInc3Data ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasInc3Data ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div
                    class="form-group"
                    data-label="4. BMI indicating Overweight or Obese:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label
                        >4. BMI indicating Overweight or Obese (Overweight - BMI
                        23-24.9. Obese - BMI more than equals to 25):</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <select
                      class="form-control"
                      [(ngModel)]="criteria.bmi"
                      name="bmi"
                      required
                      [disabled]="isInc4Disabled"
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">NA</option>
                    </select>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '4. BMI indicating Overweight or Obese:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 358px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasInc4Data || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasInc4Data || !reviewOptions.dataMonitor || userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasInc4Data ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div
                    class="form-group"
                    data-label="5. The subject is capable to give informed consent:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label
                        >5. The subject is capable to give informed
                        consent:</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <select
                      class="form-control"
                      [(ngModel)]="criteria.informedConsent"
                      name="informedConsent"
                      required
                      [disabled]="isInc5Disabled"
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">NA</option>
                    </select>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '5. The subject is capable to give informed consent:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 455px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                 <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="!hasInc5Data || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasInc5Data ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasInc5Data ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <!-- Exclusion Criteria -->
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">Exclusion Criteria</h5>
                  </div>
                  <br />
                  <div
                    class="form-group"
                    data-label="1. History of severe disease (Hypertension, renal disease, etc.):"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                      style="margin-top: 3px"
                    >
                      <label
                        >1. History of severe disease: Uncontrolled
                        hypertension, renal disease, severe heart disease, heart
                        failure, cancer or any serious illness compromising the
                        ability of subject to participate, comply with and
                        complete the study:</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <select
                      class="form-control"
                      [(ngModel)]="criteria.severeDisease"
                      name="severeDisease"
                      required
                      [disabled]="isExc1Disabled"
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">NA</option>
                    </select>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. History of severe disease (Hypertension, renal disease, etc.):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 635px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button"  (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasExc1Data ||
            userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasExc1Data ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasExc1Data ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div
                    *ngIf="formData.gender && formData.gender !== 'Male'"
                    class="form-group"
                    data-label="2. Pregnant or lactating woman:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label>2. Pregnant or lactating woman:</label>
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <select
                      class="form-control"
                      [(ngModel)]="criteria.pregnancy"
                      name="pregnancy"
                      required
                      [disabled]="isExc2Disabled"
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">NA</option>
                    </select>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '2. Pregnant or lactating woman:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 737px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasExc2Data ||
            userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasExc2Data ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasExc2Data ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div
                    class="form-group"
                    data-label="3. Any medication that may impact the study:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label
                        >3. Any medication that may impact the study:</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <select
                      class="form-control"
                      [(ngModel)]="criteria.medicationImpact"
                      name="medicationImpact"
                      required
                      [disabled]="isExc3Disabled"
                    >
                      <option value="">-- Select --</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                      <option value="na">NA</option>
                    </select>
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
      <div
  class="options-modal"
  *ngIf="
    isOptionsModalOpen &&
                      fieldLabel ===
                        '3. Any medication that may impact the study:'
  "
  (click)="$event.stopPropagation()"
  [ngStyle]="{
    'margin-top': formData.gender === 'female' ? '807px' :
                 formData.gender === 'male' ? '737px' :
                 '737px',
    'margin-right': '50px'
  }"
>
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                 <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasExc3Data || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasExc3Data ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasExc3Data ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- ELIGIBILITY ASSESSMENT FORM -->
          <div *ngIf="formName === 'eligibility-assessment'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Eligibility Assessment</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="Has the subject enrolled in the study"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                    style="margin-top: 3px"
                  >
                    <label>Has the subject enrolled in the study?</label>
                    <!-- Menu Icon -->
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div class="radio-group">
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="enrolledYes"
                        name="enrolled"
                        value="yes"
                        [(ngModel)]="formData.enrolled"
                        (change)="checkEligibility()"
                        required
                        [disabled]="isR13Disabled"
                      />
                      <span>Yes</span>
                    </label>
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="enrolledNo"
                        name="enrolled"
                        value="no"
                        [(ngModel)]="formData.enrolled"
                        (change)="checkEligibility()"
                        required
                        [disabled]="isR14Disabled"
                      />
                      <span>No</span>
                    </label>
                  </div>

                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Has the subject enrolled in the study'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 45px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button"  (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
      <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                              !hasEligibilityData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasEligibilityData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                              !hasEligibilityData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <!-- Dropdown field when No is selected -->
                  <div class="mt-4" *ngIf="formData.enrolled === 'no'">
                    <label>Reason for the Screening Failure:</label>
                    <select
                      class="form-control"
                      [(ngModel)]="formData.screeningFailure"
                      name="screeningFailure"
                      required
                      [disabled]="isEligibilitySelectDisabled"
                    >
                      <option value="" disabled>Select a reason</option>
                      <option value="Did not meet Inclusion criteria">
                        Did not meet Inclusion criteria
                      </option>
                      <option value="Met Exclusion Criteria">
                        Met Exclusion Criteria
                      </option>
                      <option value="Subject Withdrew Consent">
                        Subject Withdrew Consent
                      </option>
                    </select>
                  </div>
                </div>

                <div class="text-end">
                  <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- End of Screening Visit Form -->
          <div *ngIf="formName === 'end-of-screening'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">End of Screening Visit</h5>
            </div>
            <br />

            <div class="card-body" style="margin-top: -32px">
              <form (ngSubmit)="submitForm()">
                <div class="form-container">
                  <div
                    class="form-group mt-2"
                    data-label="Principal Investigator’s Signature:"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label for="investigatorSignature"
                        >Principal Investigator’s Signature:</label
                      >
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="investigatorSignature"
                      [(ngModel)]="formData.investigatorSignature"
                      name="investigatorSignature"
                      required
                      placeholder="Digital signature"
                      [disabled]="isSignDisabled"
                    />
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Principal Investigator’s Signature:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: -10px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button"  (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                 <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasPrincipalSignData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasPrincipalSignData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasPrincipalSignData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div class="form-group" data-label="Date:">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <label for="screeningDate">Date:</label>
                      <!-- Menu Icon -->
                      <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                        style="margin-bottom: 8px"
                      >
                        ⋮
                      </div>
                    </div>
                    <input
                      type="date"
                      class="form-control"
                      id="screeningDate"
                      [(ngModel)]="formData.screeningDate"
                      name="screeningDate"
                      [min]="screeningMinDate"
                      [max]="todayDate"
                      required
                      [disabled]="isEndDDisabled"
                    />
                  </div>
                  <!-- start of : -->
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="isOptionsModalOpen && fieldLabel === 'Date:'"
                    (click)="$event.stopPropagation()"
                    style="margin-right: 50px; margin-top: 86px"
                  >
                    <div class="modal-buttons">
                      <button (click)="openModal()">Query</button>
                      <button (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn btn-primary"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn btn-secondary"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                 <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasEndDData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasEndDData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasEndDData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <!-- Query Modal -->
                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong> -
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}
                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>

                              <!-- Footer Buttons -->
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                >
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- end of :-->

                  <div class="text-end">
                    <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                    <button type="submit" class="btn custom-button">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
